export const LEAD_REQUIRED_FIELDS_MESSAGE =
  'Заполните обязательные поля: имя и контакт (email или телефон).'

type LeadCoreFields = {
  name: string
  email: string
  phone: string
}

function trimToString(value: unknown): string {
  return typeof value === 'string' ? value.trim() : ''
}

export function normalizeLeadCoreFields(input: {
  name?: unknown
  email?: unknown
  phone?: unknown
}): LeadCoreFields {
  return {
    name: trimToString(input.name),
    email: trimToString(input.email),
    phone: trimToString(input.phone),
  }
}

export function validateLeadCoreFields(input: {
  name?: unknown
  email?: unknown
  phone?: unknown
}): { ok: true } | { ok: false; message: string } {
  const { name, email, phone } = normalizeLeadCoreFields(input)
  const hasName = name.length > 0
  const hasContact = email.length > 0 || phone.length > 0

  if (hasName && hasContact) {
    return { ok: true }
  }

  return {
    ok: false,
    message: LEAD_REQUIRED_FIELDS_MESSAGE,
  }
}
